import React, { useEffect } from "react";
import "./projects.css";
import { scrolldownani } from "../../animationGsap/Animation";
import { useRef } from "react";

const Projects = ({ title, miniDesc, projectInfo, img, tools, projectUrl }) => {
  const proani = useRef(null);

  useEffect(() => {
    if (proani.current) {
      scrolldownani(proani.current);
    }
  }, []);
  return (
    <div className="project" ref={proani} >
      <div className="logoImg">
        <img src={img} alt={title} />
      </div>
      <div className="projectsDone">
        <h4>
          {projectUrl ? (
            <a href={projectUrl} target="_blank" rel="noopener noreferrer">
              {title}
              <span className="projectLinkHint"> ↗</span>
            </a>
          ) : (
            title
          )}
        </h4>
        <p>{miniDesc}</p>
        <p>{projectInfo}</p>
        <p>Tools & Technologies Used : {tools}</p>
      </div>
    </div>
  );
};

export default Projects;
